const registerArchivedTableAccordion = () => {
  $('.accordion')
    .accordion({
      selector: {
        trigger: '.title'
      }
    });
};

const registerActiveArchivedList = () => {
  registerArchivedTableAccordion();
};

window.registerActiveArchivedList = registerActiveArchivedList;
